export default __webpack_public_path__ + "001be0758fceb7e38fbae46496285de0.svg";